"use client";

import { c as _c } from "react/compiler-runtime";
import { LogotypeIcon } from "#/components/atoms/icon-logotype";
import { env } from "#/utilities/env";
import * as AccessibleIcon from "@radix-ui/react-accessible-icon";
import { useIntersectionObserver } from "@react-hookz/web";
import { Link } from "@repo/components/atoms";
import { cn } from "@repo/lib";
import { type RefObject, useRef } from "react";
import type { Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { useGetIntl } from "@repo/i18n/client";
export function Logo(t0) {
  const $ = _c(26);
  const {
    blend,
    className,
    dictionaryPromise,
    lang
  } = t0;
  const rootRef = useRef(null);
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      threshold: [0, 0.5]
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const rootIntersection = useIntersectionObserver(rootRef as RefObject<HTMLDivElement>, t2);
  const intersecting = (rootIntersection?.intersectionRatio ?? 0) > 0 || (rootIntersection?.boundingClientRect?.top ?? 0) < 0;
  const position = intersecting ? "absolute" : "fixed";
  const t3 = blend && "mix-blend-difference";
  let t4;
  if ($[4] !== className || $[5] !== t3) {
    t4 = cn("pointer-events-none relative inset-0 z-50 grid fill-foreground", t3, className);
    $[4] = className;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== position) {
    t5 = {
      position
    };
    $[7] = position;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className) {
    t6 = cn("pointer-events-auto focus-visible:scale-110 hover:scale-110 hover:**:scale-none transition-all", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `/${lang}`;
  let t8;
  if ($[11] !== intl) {
    t8 = intl.formatMessage({
      id: "yVFeBl",
      defaultMessage: "{siteName} logotype",
      description: "Accessible label for the site logo"
    }, {
      siteName: env.NEXT_PUBLIC_SITE_NAME
    });
    $[11] = intl;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LogotypeIcon className={cn("h-8 transition duration-300 ease-in-out sm:h-10 drop-shadow-xs")} />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <AccessibleIcon.Root label={t8}>{t9}</AccessibleIcon.Root>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t6 || $[18] !== t7) {
    t11 = <Link className={t6} href={t7}>{t10}</Link>;
    $[16] = t10;
    $[17] = t6;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t5) {
    t12 = <div className="bottom-12 grid w-full justify-items-center justify-self-center" ref={rootRef} style={t5}>{t11}</div>;
    $[20] = t11;
    $[21] = t5;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t4) {
    t13 = <div className={t4} ref={rootRef}>{t12}</div>;
    $[23] = t12;
    $[24] = t4;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}